module.exports = __webpack_public_path__ + "img/H15-2.01b0b56a.jpg";